(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-posts"] && !window.DesignMode) return;
  try {
    
  var $swiperSelector = $('.blog_slider');

  $swiperSelector.each(function(index) {
    var $this = $(this);
    $this.addClass("swiper-slider-" + index);

    var dragSize = $this.data('drag-size') ? $this.data('drag-size') : 50;
    var freeMode = $this.data('free-mode') ? $this.data('free-mode') : false;
    var loop = $this.data('loop') ? $this.data('loop') : false;

    var swiper = new Swiper(".blog_slider.swiper-slider-" + index, {
      direction: "horizontal",
      loop: loop,
      freeMode: freeMode,
      slidesPerView: 4,
      slidesPerGroup: 1,
      breakpoints: {
        1920: {
          slidesPerView: 4,
          spaceBetween: 20
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 20
        },
        993: {
          slidesPerView: 3,
          spaceBetween: 10
        },
        767: {
          slidesPerView: 4,
          spaceBetween: 10
        },
        575: {
          slidesPerView: 3,
          spaceBetween: 10
        },
        320: {
          slidesPerView: 1,
          spaceBetween: 2
        }
      },
      navigation: {
        nextEl: '.swiper-button-next-old',
        prevEl: '.swiper-button-prev-old',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
        formatFractionCurrent: function (number) {
          return ('' + number).slice(-2);
        },
        formatFractionTotal: function (number) {
          return ('' + number).slice(-2);
        },
        renderFraction: function (currentClass, totalClass) {
          return  '<div class="swiper-button-prev swiper-button-prev-old"></div>'+
            '<span class="' + currentClass + '"></span>' +
            '<span> / </span>' +
            '<span class="' + totalClass + '"></span>' +
            '<div class="swiper-button-next swiper-button-next-old"></div>';
          },
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
        dragSize: '90',
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-collection-slider"] && !window.DesignMode) return;
  try {
    
  var swiper = new Swiper(".collection_slider_section .collection_slider", {
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    onlyExternal: true,
    navigation: {
      nextEl: ".swiper-button-next-new",
      prevEl: ".swiper-button-prev-new",
    },
  });

  var $swiperSelector = $('.collection_slider_section .collection_slider_product_wrapper');
  $swiperSelector.each(function(index) {
    var $this = $(this);
    $this.addClass("swiper-slider-" + index);

    var dragSize = $this.data('drag-size') ? $this.data('drag-size') : 50;
    var freeMode = $this.data('free-mode') ? $this.data('free-mode') : false;
    var loop = $this.data('loop') ? $this.data('loop') : false;

    var swiper = new Swiper(".collection_slider_product_wrapper.swiper-slider-" + index, {
      direction: "horizontal",
      loop: loop,
      freeMode: freeMode,
      slidesPerGroup: 1,
      breakpoints: {
        1920: {
          slidesPerView: 3,
          spaceBetween: 20
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 20
        },

        768: {
          slidesPerView: 2,
          spaceBetween: 40
        },
        320: {
          slidesPerView: 2,
          spaceBetween: 20
        }
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["late-award-flash-sale-products"] && !window.DesignMode) return;
  try {
    

  const allSections= document.querySelectorAll(".flash-recommended-container")
  allSections.forEach((section,index)=> section.setAttribute("id", "section-"+index))
  
  $(document).ready(function() {
    $('#recommended-products-1').click(function() {
      $('html, body').animate({
        scrollTop: $(`#section-0`).offset().top - 140
      }, 1000);
    });
  });
  
  $(document).ready(function() {
    $('#recommended-products-2').click(function() {
      $('html, body').animate({
        scrollTop: $(`#section-1`).offset().top - 140
      }, 1000);
    });
  });
  
  $(document).ready(function() {
    $('#recommended-products-3').click(function() {
      $('html, body').animate({
        scrollTop: $(`#section-2`).offset().top - 140
      }, 1000);
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promi-page-bf-creators"] && !window.DesignMode) return;
  try {
    
  $('.creator-slider').slick({
   slidesToShow: 1,
   slidesToScroll: 1,
   dots: true,
   arrows: true,
   infinite: false,
   focusOnSelect: true,
    responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
      },
    }
  ]
 })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-banner"] && !window.DesignMode) return;
  try {
    
  function onScroll() {
    const nav = document.querySelector('[data-sp-nav]');

    if (window.pageYOffset > 600) {
      nav.classList.add('stick');
    } else {
      nav.classList.remove('stick');
    }
  }

  // Add event listeners for scrolling
  window.addEventListener('scroll', onScroll);
  window.addEventListener('resize', onScroll);
  onScroll(); // Check on page load in case the element is already in the viewport

  $(document).on('click', '.spNav__left a[href^="#"]', function (event) {
    event.preventDefault();

    var targetElement = event.currentTarget;
    var indicatorElement = $('.indicator');

    if (window.innerWidth <= 767) {
      $('html, body').animate(
        {
          scrollTop: $($.attr(this, 'href')).offset().top - 194,
        },
        500
      );
    } else {
      $('html, body').animate(
        {
          scrollTop: $($.attr(this, 'href')).offset().top - 232,
        },
        500
      );
    }
  });

  $(document).on('click', '.spNav__right a[href^="#"]', function (event) {
    event.preventDefault();

    if (window.innerWidth <= 767) {
      $('html, body').animate(
        {
          scrollTop: $($.attr(this, 'href')).offset().top - 194,
        },
        500
      );
    } else {
      $('html, body').animate(
        {
          scrollTop: $($.attr(this, 'href')).offset().top - 232,
        },
        500
      );
    }

    window.addEventListener('hashchange', function () {
      var hash = window.location.hash;
      var targetElement = document.querySelector(hash);
      var indicatorElement = document.querySelector('.indicator');

      if (targetElement) {
        var targetPosition = targetElement.getBoundingClientRect();
        indicatorElement.style.left = targetPosition.left + 'px';
        indicatorElement.style.width = targetPosition.width + 'px';
      }
    });
  });

  $(window).on('scroll', function () {
    if (window.innerWidth <= 767) {
      var scrollPos = $(document).scrollTop() + 194;
    } else {
      var scrollPos = $(document).scrollTop() + 232;
    }
    // Add the offset to the scroll position
    var indicatorElement = $('.indicator');

    $('.spNav__left a').each(function () {
      var currLink = $(this);
      var refElement = $(currLink.attr('href'));

      if (refElement.position().top <= scrollPos && refElement.position().top + refElement.height() > scrollPos) {
        var targetPosition = currLink[0].getBoundingClientRect();
        indicatorElement.css('left', targetPosition.left + 'px');
        indicatorElement.css('width', targetPosition.width + 'px');
      }
    });
  });

  $(document).ready(function () {
    var firstLink = $('.spNav__left a').first();
    var indicatorElement = $('.indicator');
    var targetPosition = firstLink[0].getBoundingClientRect();

    indicatorElement.css('left', targetPosition.left + 'px');
    indicatorElement.css('width', targetPosition.width + 'px');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-offer"] && !window.DesignMode) return;
  try {
    
  const offerButtons = document.querySelectorAll('[data-offer-code]');
  offerButtons.forEach(function (ofr) {
    ofr.addEventListener('click', function () {
      navigator.clipboard.writeText(ofr.getAttribute('data-offer-code'));
      document.querySelector('.tooltip_copied').classList.add('active');
      setTimeout(function () {
        document.querySelector('.tooltip_copied').classList.remove('active');
      }, 3000);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-skin-info"] && !window.DesignMode) return;
  try {
    
  const swiper = new Swiper('.skinInfo-swiper', {
    loop: false,
    slidesPerView: 1.9,
    spaceBetween: 30,
    pagination: {
      el: '.skinInfoPagination',
      clickable: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 2.9,
      },
      768: {
        slidesPerView: 4,
        spaceBetween: 80,
      },
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-video"] && !window.DesignMode) return;
  try {
    
  const swiper = new Swiper('.spVideo-swiper', {
    loop: false,
    slidesPerView: 1,
    spaceBetween: 30,
    pagination: {
      el: '.skinInfoPagination',
      clickable: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
      },
    },
  });

  } catch(e) { console.error(e); }
})();
})();
